export enum RepoTab {
  Codes = "codes",
  PR = "pr",
  Issues = "issues",
  Settings = "settings",
}
